/**
 * 404 / Page not found — all site locales
 * title, message, homeCta; htmlLang for <html lang="…">
 */
export const notFoundTexts = {
    EN: {
        title: '404 – Page not found',
        message: 'Sorry, we cannot find that page. It may have been moved, renamed, or the address may be incorrect.',
        homeCta: 'Go to homepage',
        htmlLang: 'en',
    },
    'EN-CA': {
        title: '404 – Page not found',
        message: 'Sorry, we cannot find that page. It may have been moved, renamed, or the address may be incorrect.',
        homeCta: 'Go to homepage',
        htmlLang: 'en-CA',
    },
    DE: {
        title: '404 – Seite nicht gefunden',
        message: 'Die angeforderte Seite existiert nicht oder wurde verschoben. Bitte prüfen Sie die Adresse.',
        homeCta: 'Zur Startseite',
        htmlLang: 'de',
    },
    'DE-CH': {
        title: '404 – Seite nicht gefunden',
        message: 'Die angeforderte Seite existiert nicht oder wurde verschoben. Bitte prüfen Sie die Adresse.',
        homeCta: 'Zur Startseite',
        htmlLang: 'de-CH',
    },
    FR: {
        title: '404 – Page non trouvée',
        message: 'Désolé, la page que vous recherchez est introuvable. Elle a peut-être été déplacée ou le lien est incorrect.',
        homeCta: "Retour à l'accueil",
        htmlLang: 'fr-CH',
    },
    'FR-FR': {
        title: '404 – Page non trouvée',
        message: 'Désolé, la page que vous recherchez est introuvable. Elle a peut-être été déplacée ou le lien est incorrect.',
        homeCta: "Retour à l'accueil",
        htmlLang: 'fr',
    },
    'FR-CA': {
        title: '404 – Page non trouvée',
        message: 'Désolés, la page que vous cherchez est introuvable. Elle a peut-être été déplacée ou le lien est erroné.',
        homeCta: "Retour à l'accueil",
        htmlLang: 'fr-CA',
    },
    NL: {
        title: '404 – Pagina niet gevonden',
        message: 'Deze pagina bestaat niet of is verplaatst. Controleer het adres of probeer de startpagina.',
        homeCta: 'Naar de startpagina',
        htmlLang: 'nl',
    },
    IT: {
        title: '404 – Pagina non trovata',
        message: "Non riusciamo a trovare la pagina richiesta. Potrebbe essere stata spostata oppure l'indirizzo non è corretto.",
        homeCta: 'Vai alla home',
        htmlLang: 'it',
    },
    'IT-CH': {
        title: '404 – Pagina non trovata',
        message: "Non riusciamo a trovare la pagina richiesta. Potrebbe essere stata spostata oppure l'indirizzo non è corretto.",
        homeCta: 'Vai alla home',
        htmlLang: 'it-CH',
    },
    CZ: {
        title: '404 – Stránka nenalezena',
        message: 'Požadovanou stránku nelze najít. Možná byla přesunuta nebo je adresa nesprávná.',
        homeCta: 'Zpět na úvodní stránku',
        htmlLang: 'cs',
    },
    FI: {
        title: '404 – Sivua ei löydy',
        message: 'Etsimääsi sivua ei löydy. Se on saatettu siirtää tai osoite voi olla virheellinen.',
        homeCta: 'Siirry etusivulle',
        htmlLang: 'fi',
    },
    PL: {
        title: '404 – Strona nie znaleziona',
        message: 'Nie możemy znaleźć tej strony. Mogła zostać przeniesiona lub adres jest nieprawidłowy.',
        homeCta: 'Przejdź do strony głównej',
        htmlLang: 'pl',
    },
    SE: {
        title: '404 – Sidan hittades inte',
        message: 'Vi hittar inte sidan du söker. Den kan ha flyttats eller så är adressen felaktig.',
        homeCta: 'Till startsidan',
        htmlLang: 'sv',
    },
    NO: {
        title: '404 – Siden ble ikke funnet',
        message: 'Vi finner ikke siden du leter etter. Den kan ha blitt flyttet, eller adressen kan være feil.',
        homeCta: 'Gå til forsiden',
        htmlLang: 'nb',
    },
    DK: {
        title: '404 – Siden blev ikke fundet',
        message: 'Vi kan ikke finde den side, du leder efter. Den er måske blevet flyttet, eller adressen er forkert.',
        homeCta: 'Gå til forsiden',
        htmlLang: 'da',
    },
    ES: {
        title: '404 – Página no encontrada',
        message: 'No encontramos esa página. Puede haberse movido o la dirección no es correcta.',
        homeCta: 'Ir a la página de inicio',
        htmlLang: 'es',
    },
};
